import React from 'react';
import { FiAlertCircle, FiBarChart2, FiRefreshCw } from 'react-icons/fi';

export const ReportPageLayout = ({ reportId, children }) => (
  <main className={`bw_main_wrapp bc_rr_page bc_rr_page--${reportId || 'report'}`}>{children}</main>
);

export const ReportPageHeader = ({
  title,
  description,
  breadcrumb = 'Bán hàng / Báo cáo bán hàng',
  actions,
}) => (
  <header className='bc_rr_page_header'>
    <div className='bc_rr_page_header_copy'>
      <div className='bc_rr_breadcrumb' aria-label='Đường dẫn trang'>
        {breadcrumb}
      </div>
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </div>
    {actions ? <div className='bc_rr_page_actions'>{actions}</div> : null}
  </header>
);

export const ReportContextBar = ({ items = [] }) => (
  <section className='bc_rr_context_bar' aria-label='Phạm vi báo cáo'>
    {items.filter((item) => item?.value).map((item) => (
      <div className='bc_rr_context_item' key={`${item.label}-${item.value}`} title={`${item.label}: ${item.value}`}>
        <span>{item.label}:</span>
        <strong>{item.value}</strong>
      </div>
    ))}
  </section>
);

export const ReportKpiCard = ({ metric }) => (
  <article className='bc_rr_metric_card'>
    <span className='bc_rr_metric_label'>{metric.label}</span>
    <strong className={`bc_rr_metric_value${metric.unavailable ? ' is-unavailable' : ''}`}>{metric.value}</strong>
    <div className={`bc_rr_metric_delta ${metric.tone ? `is-${metric.tone}` : 'is-neutral'}`}>
      <span>{metric.delta}</span>
      <small>{metric.note}</small>
    </div>
  </article>
);

export const ReportKpiGrid = ({ metrics = [] }) => (
  <section className='bc_rr_metrics_grid' aria-label='Chỉ số tổng quan'>
    {metrics.map((metric) => <ReportKpiCard key={metric.label} metric={metric} />)}
  </section>
);

export const ReportState = ({ type = 'empty', children }) => {
  const Icon = type === 'loading' ? FiRefreshCw : type === 'error' ? FiAlertCircle : FiBarChart2;
  return (
    <section className={`bc_rr_report_state is-${type}`} role={type === 'error' ? 'alert' : 'status'}>
      <Icon aria-hidden='true' />
      <span>{children}</span>
    </section>
  );
};

export const ReportTableToolbar = ({ summary, actions }) => (
  <section className='bc_rr_toolbar' aria-label='Tổng hợp và thao tác bảng'>
    <div className='bc_rr_toolbar_summary'>{summary}</div>
    {actions ? <div className='bc_rr_toolbar_actions'>{actions}</div> : null}
  </section>
);
